import AddEmail from "../components/configuration/email/AddEmail";

const AddEmailPage = () => {
    return(
        <AddEmail/>
    )
}

export default AddEmailPage;
